import { get, handleResponse, postAuth } from "./base.service";
import { CONTROLLER, ACTION } from "../utilities/api.constants";

export const getMemberFek = (basvuruNedeni) => {
  return get(CONTROLLER.WORKFLOW + ACTION.GET_MEMBER_FEK + "?basvuruNedeni=" + basvuruNedeni)
    .then(handleResponse);
};
export const addFeedback = (konu, aciklama, basvuruNedeni, uyeNo, adiSoyadi, tckn, babaAdi, unvan, vkn, mersisNo, iban, telNo) => {
  var data = {
    konu,
    aciklama,
    basvuruNedeni,
    uyeNo, 
    adiSoyadi, 
    tckn, 
    babaAdi, 
    unvan, 
    vkn, 
    mersisNo, 
    iban, 
    telNo
  };
  return postAuth(CONTROLLER.WORKFLOW + ACTION.ADD_FEEDBACK, data).then(
    handleResponse
  );
};

export const askToAgent = (konu, aciklama) => {
  var data = {
    konu,
    aciklama,
    basvuruNedeni: "2"
  };
  return postAuth(CONTROLLER.WORKFLOW + ACTION.ASK_TO_AGENT, data).then(
    handleResponse
  );
};

export const getMyDemand = () => {
  return get(CONTROLLER.WORKFLOW + ACTION.GET_MY_DEMANDS).then(handleResponse);
};

export const getMemberIban = () => {
  return get(CONTROLLER.WORKFLOW + ACTION.GET_MEMBER_IBAN)
    .then(handleResponse);
};